import React from "react"
import { Link } from "react-router-dom"
import moment from "moment-timezone"
import { capitalize } from "lodash"
import "assets/scss/custom/components/_directoryActions.scss"

export const LEAD_TIMEZONE = "Europe/Bucharest"

const listColumns = (leadListSearch = "") => [
  {
    dataField: "clubName",
    text: "Club lead",
    formatter: (value, lead) => (
      <div className="lead-identity">
        <Link to={{ pathname: `/accounts/clubs-leads/${lead.id}`, state: { leadListSearch } }} className="club-list-name">
          {value || "Unnamed club"}
        </Link>
        <span className="club-list-meta">
          {lead.leadId != null ? `#${lead.leadId}` : "ID not specified"}
        </span>
        <span className="club-list-meta">
          {[lead.location?.city, lead.location?.country].filter(Boolean).join(", ") ||
            "Location not specified"}
        </span>
      </div>
    ),
  },
  {
    dataField: "email",
    text: "Contact",
    formatter: (value, lead) => (
      <div className="lead-contact">
        <span className="font-weight-medium">
          {[lead.firstName, lead.lastName].filter(Boolean).join(" ") ||
            "Contact not specified"}
        </span>
        {value ? <a href={`mailto:${value}`}>{value}</a> :
          <span className="club-list-meta">Email not specified</span>}
        {lead.phone ? <a href={`tel:${lead.phone}`}>{lead.phone}</a> :
          <span className="club-list-meta">Phone not specified</span>}
      </div>
    ),
  },
  {
    dataField: "sports",
    text: "Sports & courts",
    formatter: (value, lead) => (
      <div className="lead-facilities">
        {value?.length ? (
          <div className="lead-sports">
            {value.map(sport => <span className="badge badge-light" key={sport}>{capitalize(sport)}</span>)}
          </div>
        ) : <span className="club-list-meta">Sports not specified</span>}
        <span className="club-list-meta">
          {lead.noCourts != null ? `${lead.noCourts} ${Number(lead.noCourts) === 1 ? "court" : "courts"}` :
            "Courts not specified"}
        </span>
      </div>
    ),
  },
  {
    dataField: "createdAt",
    text: "Status / Created",
    formatter: (value, lead) => {
      const created = value ? moment(value).tz(LEAD_TIMEZONE) : null
      return (
        <div className="lead-created">
          <span className={`badge badge-${lead.status === "closed" ? "success" : "info"}`}>
            {lead.status ? capitalize(lead.status) : "Status not specified"}
          </span>
          {created?.isValid() ? (
            <time dateTime={created.toISOString()} title={`${created.format("YYYY-MM-DD HH:mm:ss Z")} (${LEAD_TIMEZONE})`}>
              <span>{created.format("D MMM YYYY")}</span>
              <span className="club-list-meta">{created.format("HH:mm:ss")}</span>
            </time>
          ) : <span className="club-list-meta">Date not specified</span>}
        </div>
      )
    },
  },
  {
    dataField: "actions",
    text: "Actions",
    formatter: (value, lead) => (
      <Link to={{ pathname: `/accounts/clubs-leads/${lead.id}`, state: { leadListSearch } }}
        className="btn btn-outline-primary btn-sm lead-open directory-action-button"
        aria-label={`Open lead: ${lead.clubName || lead.leadId || "Unnamed club"}`}>
        Open
      </Link>
    ),
  },
]

export default listColumns
